import { Car01, User01 } from "@untitledui/icons";
import { cx } from "@/utils/cx";

export type RankingModeToggleProps = {
	isDriver: boolean;
	onModeChange: (isDriver: boolean) => void;
};

const activeSegmentClass =
	"bg-[var(--Colors-Background-bg-primary,#FFF)] text-primary font-semibold";

const inactiveSegmentClass =
	"bg-[var(--Colors-Background-bg-active,#F5F5F5)] text-tertiary font-medium";

function segmentClassName(isActive: boolean): string {
	return cx(
		"inline-flex h-9 shrink-0 cursor-pointer items-center justify-center gap-2 px-3 text-sm transition-colors",
		"-outline-offset-2 border-0 outline-focus-ring focus-visible:z-10 focus-visible:outline-2",
		isActive ? activeSegmentClass : inactiveSegmentClass,
		"hover:brightness-[0.99] active:brightness-[0.97]"
	);
}

export function RankingModeToggle({
	isDriver,
	onModeChange,
}: RankingModeToggleProps) {
	return (
		<fieldset
			className="m-0 inline-flex h-9 w-fit min-w-0 overflow-hidden rounded-lg border border-border-primary p-0"
			data-slot="ranking-mode-toggle"
		>
			<legend className="sr-only">Modo de visualização do ranking</legend>
			<button
				aria-pressed={isDriver}
				className={segmentClassName(isDriver)}
				onClick={() => {
					onModeChange(true);
				}}
				type="button"
			>
				<User01 className="size-5 shrink-0" />
				Por motorista
			</button>
			<div
				aria-hidden
				className="w-px shrink-0 self-stretch bg-border-primary"
			/>
			<button
				aria-pressed={!isDriver}
				className={segmentClassName(!isDriver)}
				onClick={() => {
					onModeChange(false);
				}}
				type="button"
			>
				<Car01 className="size-5 shrink-0" />
				Por veículo
			</button>
		</fieldset>
	);
}
